import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { Button, Typography } from "@mui/material";
import { PageContainer } from "@/features/ui";

import {
  ADD_ID,
  CYL_ID,
  SIDE_ID,
  SPH_ID,
} from "@/features/product-variant-attributes";
import { LensProductForm } from "@/features/products";
import { apiClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

export const EditLensProduct = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchOutlet = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: {
              name,
              skuPrefix,
              status,
              availableToAllOutlets,
              productCategory,
              unitOfMeasurement,
              lensProductVariantGroups,
              productAddOns,
              outlets,
              productVariantAttributeValue,
            },
          },
        } = await apiClient.get(`products/${productId}`, {
          params: {
            withLensProductVariantGroups: true,
            withOutlets: true,
            withProductCategory: true,
            withUom: true,
            withProductVariantAttributeValue: true,
            withProductAddOns: true,
          },
        });

        // Construct variant attributes
        const variantAttributes = [
          {
            id: SPH_ID,
            name: "Sph",
            checked: true,
            required: true,
          },
          {
            id: CYL_ID,
            name: "Cyl",
            checked: true,
            required: true,
          },
          {
            id: ADD_ID,
            name: "Add",
            checked: productVariantAttributeValue.variantAttribute3 !== null,
            required: false,
          },
          {
            id: SIDE_ID,
            name: "Sisi",
            checked: productVariantAttributeValue.variantAttribute4 !== null,
            required: false,
          },
        ];

        // Map the outlets
        const outletMap = outlets.reduce((acc, outlet) => {
          acc[outlet.id] = true;
          return acc;
        }, {});

        setDefaultValues({
          name,
          stockKeepingUnitPrefix: skuPrefix,
          status,
          availableToAllOutlets,
          productCategory: {
            id: productCategory.id,
            name: productCategory.name,
          },
          unitOfMeasurement: {
            id: unitOfMeasurement.id,
            name: unitOfMeasurement.name,
          },
          lensProductVariantGroups,
          variantAttributes,
          productAddOns,
          outlets: outletMap,
        });
      } catch (error) {
        setError(
          getErrorMessage(error, "Gagal memperbarui produk lensa")
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchOutlet();
  }, [productId]);

  const handleSubmit = async (data) => {
    try {
      await apiClient.put(`products/${productId}/bulk/lens`, data);
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal memperbarui produk lensa")
      );
    }
  };

  return isLoading ? (
    <CenteredLoading />
  ) : (
    <PageContainer
      maxWidth="xl"
      title="Edit Produk Lensa"
      breadcrumbs={[
        { title: "Produk Lensa", path: "/inventory/lens-products" },
        { title: "Ubah" },
      ]}
    >
      {error ? (
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      ) : (
        <LensProductForm
          disableStockKeepingUnitPrefix={true}
          isLoading={isLoading}
          defaultValues={defaultValues}
          onSubmit={handleSubmit}
          renderActionButton={({ isSubmitting }) => (
            <Button
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              Simpan
            </Button>
          )}
        />
      )}
    </PageContainer>
  );
};
